import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["PaginationEllipsis"], _mergeProps({ "data-slot": "pagination-ellipsis" }, $setup.delegatedProps, {
        class: $setup.cn('flex size-9 items-center justify-center', $setup.props.class)
    }), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
                _createVNode($setup["MoreHorizontal"], { class: "size-4" }),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "More pages", -1 /* CACHED */))
            ])
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
